import axios from "axios";

export default {
  async fetchGet(url, result = 'resultData') {
    this.isLoading = true;

    if (!this.isUserGuest()) {
      const res = await axios.get(process.env.VUE_APP_ROOT_API + url, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        }
      }).then((response) => {
        if (response.data.success) {
          this[result] = response.data.data;
        }
      }).catch(async () =>  {
        const refreshToken = await this.fetchRefreshToken();
        if (refreshToken) {
          await this.fetchGet(url);
        }
      }).finally(() => {
        this.isLoading = false;
      });
    }
  },
  async fetchPost(url, data, result = 'resultData') {
    this.isLoading = true;

    if (!this.isUserGuest()) {
      const res = await axios.post(process.env.VUE_APP_ROOT_API + url, data, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        }
      }).then((response) => {
        if (response.data.success) {
          this[result] = response.data.data;
        }
      }).catch(async () =>  {
        const refreshToken = await this.fetchRefreshToken();
        if (refreshToken) {
          await this.fetchPost(url, data);
        }
      }).finally(() => {
        this.isLoading = false;
      });
    }
  },
  async fetchRefreshToken() {
    if (!this.isUserGuest()) {
      try {
        let status = false;

        let response = await axios.post(process.env.VUE_APP_ROOT_API + '/adm/auth/refresh-token', {
          refreshToken: localStorage.getItem('refreshToken')
        });
        let jsonData = await response.data;

        if (jsonData.success) {
          localStorage.setItem('accessToken', jsonData.data.accessToken);
          localStorage.setItem('refreshToken', jsonData.data.refreshToken);
          status = true;
        } else {
          this.isLoading = false;
          this.Logout();
        }

        return status;

      } catch (e) {
        this.isLoading = false;
        this.Logout();
      }
    }
  }
}
